import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface UpdateTeamMemberParams {
  memberId: string;
  roleId?: number;
  resend?: boolean;
  is_active?: boolean;
  continueSync?: boolean;
}

export const useTeamMemberUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ memberId, ...rest }: UpdateTeamMemberParams) => {
      const response = await httpService.patch(
        `${API_CONFIG.path.teamMembers}/${memberId}`,
        rest
      );
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["team-members"] });
    },
  });
};
